import React, { useState, useEffect } from 'react';
import FeedbackForm from 'app/components/Subscription/Cancellation/FeedbackForm.jsx';
import DiscountOffer from 'app/components/Subscription/Cancellation/DiscountOffer.jsx';
import PauseOption from 'app/components/Subscription/Cancellation/PauseOption.jsx';
import GetHelp from 'app/components/Subscription/Cancellation/GetHelp.jsx';
import FullPageModal from 'app/components/common/FullPageModal.jsx';

const CancellationModal = (props) => {
    const [currentView, setCurrentView] = useState(1);
    const [ isWorking, setIsWorking ] = useState(false);

    let modalContent = null,
        nextBillingDate = props.user.plan.nextBilling;

    const goToNextView = (nextView) => {
        setCurrentView(nextView)
    }

    if (currentView === 1) {
        modalContent = (
            <div className="cancellation-start-wrapper">
                <div className="cancellation-start">
                    <div className="main-copy">
                        <p className="top-line">Cancelling your dlvr.it plan will <span className="underline">stop all social media posting.</span></p>
                        <p className="question">Do you want to continue posting to social media?</p>
                    </div>
                    <div className="action-buttons">
                        <div className="action-button main" onClick={(e) => {
                            props.closeAllModals();
                        }} role="button">
                            Yes! Keep posting
                        </div>
                        <div className="action-button secondary" onClick={(e) => {
                            setCurrentView(2);
                        }} role="button">
                            No, stop all posting
                        </div>
                    </div>
                </div>
            </div>
        );
    } else if (currentView === 2) {
        modalContent = (
            <FeedbackForm
                {...props}
                advance={goToNextView}/>
        )
    } else if (currentView === 3) {
        modalContent = (
            <DiscountOffer
                {...props}
                advance={goToNextView}/>
        );
    } else if (currentView === 4) {
        modalContent = (
            <PauseOption
                {...props}
                advance={goToNextView}/>
        );
    } else if (currentView === 6) {
        modalContent = (
            <GetHelp
                {...props}
                advance={goToNextView}/>
        );
    } else {
        let cancelLabel = 'Cancel Plan';

        if (isWorking) {
            cancelLabel = (<i className="fa fa-spinner fa-pulse"></i>);
        }
        
        modalContent = (
            <div className="cancellation-end-wrapper">
                <div className="cancellation-end">
                    <div className="final-step-header">
                        We'll miss you!
                    </div>
                    <div className="final-step">
                        Your plan will be canceled and <b>all posting will stop.</b>
                    </div>
                    <div className="final-warning">
                        All posting will stop on {moment(nextBillingDate).format("MMMM Do, YYYY")}
                    </div>
                    <div className="action-buttons">
                        <div className="action-button secondary" onClick={(e) => {
                            if (!isWorking) {
                                setIsWorking(true);
                                props.planChangeHandler({
                                    level: props.newPlanLevel,
                                    term: props.newPlanTerm,
                                    isHammertime: true,
                                    trackingAction: 'downgrade'
                                });
                            }
                        }}>
                            {cancelLabel}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <FullPageModal
            content={modalContent}
            version="headerless"
            closeAction={() => {
                props.closeAllModals();
            }}/>
    );
};

export default CancellationModal;
